import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { showCompanionRestriction } from '../redux/companionSlice';

export default function AccountOnly({ children, feature = 'Cette fonctionnalité' }) {
  const session = useSelector(state => state.companion);
  const access = useSelector(state => state.user.access);
  const dispatch = useDispatch();
  const restricted = Boolean(session.token) && !access;
  useEffect(() => {
    if (restricted) dispatch(showCompanionRestriction(feature));
  }, [dispatch, feature, restricted]);
  return restricted ? <Navigate to={`/dashboard/${session.event.id}`} replace /> : children;
}
